import { render, staticRenderFns } from "./ReportLayout.vue?vue&type=template&id=4585c6b2"
import script from "./ReportLayout.vue?vue&type=script&lang=ts"
export * from "./ReportLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports